import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"
import { REQUEST_ERRORS_CARDS_DEBTS } from "../../constants/requestErrorFlags"
import { showSnackBar } from "../Snackbar/Snackbar"
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider"
import { changeVerifiedAccountNumberDebts } from "../../features/creditReports/creditReports"
import Input from "../Input/Input"
import { LuPencil, LuCheck, LuX } from "react-icons/lu"
import { clearAlphaNumeric } from "../../utils/payment"

const VerifiedAccountNumber = ({ creditProfileId, verifiedNumber }) => {
  const dispatch = useDispatch()
  const { triggerLoading } = useMyContextLoading()
  const cardsDebtsOn = useSelector(selectFeatureFlag(REQUEST_ERRORS_CARDS_DEBTS))

  const [verifiedAccountNumber, setVerifiedAccountNumber] = useState(verifiedNumber || '')
  const [isEditing, setIsEditing] = useState(false)
  const storedNumber = useRef(verifiedNumber || '')

  const handleSave = async () => {
    triggerLoading(true)
    if (cardsDebtsOn) {
      try {
        await dispatch(
          changeVerifiedAccountNumberDebts({
            creditProfileId,
            data: { verifiedAccountNumber }
          })
        ).unwrap()
        storedNumber.current = verifiedAccountNumber
      } catch (e) {
        showSnackBar("error", typeof e === 'string' ? e : (e?.message || "Failed to update debt"))
        setVerifiedAccountNumber(storedNumber.current)
      }
      setIsEditing(false)
      triggerLoading(false)
      return
    }
    try {
      await dispatch(
        changeVerifiedAccountNumberDebts({
          creditProfileId,
          data: { verifiedAccountNumber }
        })
      )

      setIsEditing(false)
    } catch (e) {
      console.error("Error saving data", e)
    }
    triggerLoading(false)
  }

  return (
    <div className="flex items-center gap-2 underline">
      {!isEditing ? (
        <>
          <span className="cursor-pointer" onClick={() => setIsEditing(true)}>{verifiedAccountNumber || <LuPencil size={16} className="text-text-secondary" />}</span>
        </>
      ) : (
        <>
          <Input
            value={verifiedAccountNumber}
            onChange={(e) =>
              setVerifiedAccountNumber(clearAlphaNumeric(e.target.value))
            }
            width="w-full"
            placeholder="Enter number"
          />
          <div className="flex flex-col items-center justify-between h-fit gap-1">
            <button onClick={handleSave}>
              <LuCheck size={18} className="text-success-main" />
            </button>
            <button onClick={() => setIsEditing(false)}>
              <LuX size={18} className="text-text-secondary" />
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default VerifiedAccountNumber